var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#92D700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4174 47.2901C47.1156 46.4792 45.4869 46.3997 44.1124 47.0801L38.8624 41.8301C39.2511 40.9433 39.3372 39.9532 39.1074 39.0126C39.0683 38.8816 39.0215 38.7531 38.9674 38.6276L44.1124 33.4826C46.0389 34.4325 48.3704 33.8302 49.5959 32.0662C50.8214 30.3022 50.5722 27.9071 49.0098 26.4331C47.4474 24.9592 45.0419 24.8498 43.3522 26.1759C41.6625 27.502 41.197 29.8646 42.2574 31.7326L37.4099 36.5101C35.7594 35.3369 33.5195 35.4497 31.9951 36.7827C30.4708 38.1158 30.0605 40.3207 31.0032 42.1128C31.9459 43.905 33.9953 44.816 35.9574 44.3151C36.3652 44.1953 36.754 44.0186 37.1124 43.7901L42.3624 49.0401C41.2841 51.1481 42.0865 53.7313 44.1693 54.8575C46.2521 55.9837 48.8531 55.2405 50.0265 53.184C51.2 51.1275 50.5165 48.5103 48.4874 47.2901H48.4174Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.ac168184698ed51b27a54e09a68acdbd.svg";
export { ForwardRef as ReactComponent };